import React, { FC } from 'react';
import { Select } from 'antd';
import { useAppDispatch, useAppSelector } from '../../hooks/redux-hooks';
import { selectBookingTimezone, setTimezone } from '../../redux/slices/booking';
import { formatTimezone, TIMEZONES } from '../../utils/timezone';

// `at` is the appointment date, so abbreviations (AEST/AEDT) match the times shown for it.
const TimezoneSelect: FC<{ at?: string }> = ({ at }) => {
  const dispatch = useAppDispatch();
  const timezone = useAppSelector(selectBookingTimezone);
  const options = TIMEZONES.includes(timezone) ? TIMEZONES : [timezone, ...TIMEZONES];

  return (
    <div style={{ marginBottom: 16, maxWidth: 340 }}>
      <b style={{
        display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 5,
      }}
      >
        Timezone
      </b>
      <p className="fhint">Set from your postcode — change it if you&apos;re elsewhere.</p>
      <Select
        aria-label="Timezone"
        value={timezone}
        onChange={(value: string) => dispatch(setTimezone(value))}
        style={{ width: '100%' }}
        options={options.map((value) => ({ value, label: formatTimezone(value, at) }))}
      />
    </div>
  );
};

export default TimezoneSelect;
